import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ValidationManager } from '@chegg/commerce-utils';
var CCFIELDS = ValidationManager.types.CCFIELDS;
export var defaultHostedFields = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CCFIELDS.CARD_NUMBER, {
  selector: "#".concat(CCFIELDS.CARD_NUMBER)
}), CCFIELDS.EXPIRATION_DATE, {
  selector: "#".concat(CCFIELDS.EXPIRATION_DATE)
}), CCFIELDS.CVV, {
  selector: "#".concat(CCFIELDS.CVV)
}), CCFIELDS.CARDHOLDER_NAME, {
  selector: "#".concat(CCFIELDS.CARDHOLDER_NAME)
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/business/processors/braintree/DefaultHostedFields.js
// module id = 1510
// module chunks = 11